import delegate from "es6-delegate";

export default class ProductListingFilter {
  static filterListOverflowToggleSelector = "[data-toggle=filterListOverflow]";

  static filterListOverflowSelector = "[data-component=filterListOverflow]";

  static toolbarSortToggleSelector = "[data-toggle=toolbarMenu]";

  static toolbarMenuSelector = "[data-component=toolbarMenu]";

  static get delegateContainer() {
    return document.querySelector(".page-container") || document;
  }

  constructor() {
    delegate(
      ProductListingFilter.delegateContainer,
      "click",
      ProductListingFilter.filterListOverflowToggleSelector,
      ProductListingFilter.toggleOverflow,
    );
    delegate(
      ProductListingFilter.delegateContainer,
      "click",
      ProductListingFilter.toolbarSortToggleSelector,
      ProductListingFilter.openToolbarMenu,
    );
    delegate(
      ProductListingFilter.delegateContainer,
      "click",
      ProductListingFilter.toolbarMenuSelector,
      ProductListingFilter.closeToolbarMenu,
    );
  }

  static toggleOverflow(e, element) {
    e.preventDefault();

    const ele = element;
    const overflow = ele.parentNode.querySelector(
      ProductListingFilter.filterListOverflowSelector,
    );
    const overflowText = ele.textContent.trim();
    const overflowToggleNewText =
      overflowText !== "Collapse" ? "Collapse" : ele.dataset.originalText;

    overflow.classList.toggle("expanded");
    ele.textContent = overflowToggleNewText;
  }

  static openToolbarMenu(e, ele) {
    const targetEle = document.querySelector(ele.dataset.target);

    if (!targetEle) return;

    const itemLists = targetEle.querySelectorAll(
      ".filter-list__itemlist, .filter-list__heading",
    );
    const categoryFilterList = targetEle.querySelector(".category-nav");
    const categoryFilterHeader = targetEle.querySelector(".selectCategory");

    if (categoryFilterList) {
      categoryFilterList.classList.add("collapse");
    }
    if (categoryFilterHeader) {
      categoryFilterHeader.classList.add("collapsed");
    }

    itemLists.forEach((itemList) => {
      itemList.classList.remove("in");
      if (itemList.classList.contains("filter-list__itemlist")) {
        itemList.classList.add("collapse");
      } else {
        itemList.classList.add("collapsed");
      }
    });

    targetEle.classList.add("open");
    document.body.classList.add("modal-open");
  }

  static closeToolbarMenu(e, ele) {
    if (
      e.target.closest("a, form") &&
      !e.target.closest("[data-dismiss=toolbarMenu]")
    )
      return;

    e.preventDefault();

    if (
      !e.target.closest("[data-component=filterContainer]") ||
      e.target.closest("[data-dismiss=toolbarMenu]")
    ) {
      ele.classList.remove("open");
      document.body.classList.remove("modal-open");
    }
  }
}
